module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/mrescir14-1ed60aa9d8cfc5832509246f7961c911.jpg";